import { createFileRoute } from "@tanstack/react-router";
import {
  CollectionPage,
  collectionLoader,
  collectionHeadDa,
  CollectionErrorComponent,
  CollectionNotFoundComponent,
} from "@/pages/CollectionPage";

export const Route = createFileRoute("/collections/$handle")({
  loader: collectionLoader,
  head: collectionHeadDa,
  component: CollectionPage,
  errorComponent: CollectionErrorComponent,
  notFoundComponent: CollectionNotFoundComponent,
});
